"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "spoleto": {
    "d5fa878d": [{
      "hkey": "01fd5602",
      "slug": "cortaccione-madonna-di-lugo",
      "name": "Cortaccione-Madonna di Lugo",
      "primary": true,
      "skipSearch": false
    }],
    "cortaccione": [{
      "hkey": "01fd5602",
      "slug": "cortaccione-madonna-di-lugo",
      "name": "Cortaccione-Madonna di Lugo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;